module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "oa-breadcrumb"
  }, [_c('span', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    staticClass: "breadcrumb-link",
    on: {
      "click": _vm.goIndex
    }
  }, [_vm._v(_vm._s(this.$route.params.language == 'zh' ? '首页' : 'Home'))]), _vm._v(" "), _c('span', {
    staticClass: "sep"
  }, [_vm._v(_vm._s(_vm.separator))])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('app-breadcrumb-item', {
      attrs: {
        "item": item
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a94534d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppBreadcrumb.vue
// module id = 31
// module chunks = 2 3 4 5 6